import React from "react";


export const IndeterminateProgressBar = () =>
    <div className='w-full'>
        <div className='h-2.5 w-full bg-gray-100 overflow-hidden rounded-xl'>
            <div className='progress w-full h-full bg-blue-500 left-right'></div>
        </div>
    </div>